import React from 'react';

interface SvgNetworkProps {
  color?: string;
  width?: number;
  height?: number;
}



const SvgPiggy: React.FC<SvgNetworkProps> = ({
  color = '#292D32',
  width = 24,
  height = 24
}) => {
  return (
    <svg
      width={width} 
      height={height} 
      viewBox="0 0 250 250" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="250" height="250" fill={"url(#pattern0_2015_25)"}/>
      <defs>
        <pattern id="pattern0_2015_25" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref="#image0_2015_25" transform="scale(0.0111111)"/>
        </pattern>
        <image id="image0_2015_25" width="90" height="90" preserveAspectRatio="none" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAES0lEQVR4nO2cXYhVVRTHfyXdigp9qETxpY+pKMp885MKK/qA8iHoISxC8skgQfADnRm0EYPyIZ/CnqLoi76g8jGKSiRjemjQHvRBHHUIs0zNSl2xYV24DM3cc+/eZ+91ztk/+HOZh7PvXv85Z+91915nQyaTyWQymUyTuBcYAfYBx4B/9NP9/TIwP3UHq85twKeAFNDHwEDqDleRR4DfC5rc1mngidQdrxKPAxd6NLktd92jqQOoynDxR58mt+WehFtSB2KdzzxNbuuj1IFYZkEgk50u5WxkakYCGu20NeJNUin2BTZ6b+qArHIisNHjqQOyyt+BjT6fOiCrjAc2+mjqgKyyN7DR36cOyCpbAxs9nDogq9yj+W8Ik107d6cOyDIfBjL6/dSBWOdm4JSnye76m1IHUgXu80j13OrdY6kDyITnLp10R0tou5JcBmwHngfmeLZ1JzAE/NzxJP2GUa4EVgKrI33f2kkZyU/ADmCph7mdOoAxrgEGgQnt4EVgRcnf6XZc/p1mXB8DXgRm9mhup77E0KO7SnevJ3fyTA93Vq+4dv8sOJG6fuzWMbeIuZ1y/5Dk3Ah83qWjZ4EHA3/vMt2wlQi6n8Qs6Rgm6qrzwNUpTV7ew2MrFdZ7KU1+uIT1ZTGqB1KZfHuAn9FSEY3pRB+dqzSnlIZoBTVZUxbD+iqVyQM6A0tD9EmqYeNNA8FLZG2ObfJs4C8DgUtkXdQ0NhrrDQQtiXRI13Ci8J2BgCWhXo1h8g0e9cxSE7kkYF4Z5raAV3Q17pyBQCWg3ALXFq2xbunnYIE4d5Vh9A4DhkhJJi+cIuZFXcx2ycAs6+VbYkTuTp6OoS7Xv5CNppDR3V7JuLXL9V+HNrquQ0erwF5ntzYOAtu08sqblpo93rA7eqDH9g7qcHRdCNOn2/ismga7xDrcZ7tHgLm+Rp80YJAE0jnNLv6PxZ6p7Lu+Rh8yYJAENntIJ76Wfg4HWMtxN6QX+w2YIxXQcV+j3zEQhFRAe3yNXmcgCKmANvgavdxAEFIBTfXTvjDXNnTRX3qQq2+5ggAUPcCkqdpDIJ41EIzUeXxuMytiQaE0cXzu5DUDAUmdx+c28xpUbyc96AMMvycoNdHpsl4s3WggODGgU5ppuFN1SuFJA0FKIj1HRLpt9dRV38Suw5tRw/IDKTAOu5rw6IwaCF4iyb2z+BSJeNuAARJJbvJPxiYDBkgEJX+3sO6ZxwVgDQaoc+YxATyEEeqaeRzVgntTjNZ0cehyjFHXzOMOjFHXzOMZjFHXzGMnxvDNPPbref27jL2JG7wsN3XmsXtSezP1TIyXgNf15PQfgcN6ntGZjnWHCS1TcxPyt8BbWtK1Uo+12Om5/GmOLzwCerrEfrmzNX7ps1+/YpDFfW5t/aAF32WytM9yY1dgbpJlulZ7tkAQx4A3gOsjTthj+vZrkUrQER0SM5lMJpPJZDKZTIbG8B9DWbCVf8KY1wAAAABJRU5ErkJggg=="/>
      </defs>
    </svg>  
  );
};

export default SvgPiggy; 